import { create } from 'zustand';
import type { GfxController } from './core/GfxController';

type CanvasStore = {
  controller: GfxController | null;
  /** 每次控制器内部状态变化自增，用于驱动 React 重渲染。 */
  revision: number;
  setController: (controller: GfxController | null) => void;
  bump: () => void;
};

export const useCanvasStore = create<CanvasStore>(set => ({
  controller: null,
  revision: 0,
  setController: controller => set({ controller, revision: 0 }),
  bump: () => set(state => ({ revision: state.revision + 1 })),
}));